/**
 * The code sign-in (D-065, D-066), its pure parts: what the person types
 * into the email and code boxes, cleaned the way the API and Supabase read it.
 */

/** The code as typed, digits only, at most six: a pasted "123 456" or "123-456" still works. */
export function cleanCode(typed: string): string {
  return typed.replace(/\D/g, '').slice(0, 6);
}

export function isCompleteCode(code: string): boolean {
  return /^\d{6}$/.test(code);
}

/** Trimmed and lower-cased, as the API compares it with Jobber's users. */
export function cleanEmail(typed: string): string {
  return typed.trim().toLowerCase();
}
